import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { REGISTRATION_STEPS } from "@tvg/atomic-ui/_static/Constants/progressBar";
import { setRFRCookie } from "@tvg/utils/PromoUtils";
import { Helmet } from "react-helmet";
import { getRedirectTVGSignup } from "@urp/store-selectors";
import Welcome from "./components/Welcome";
import AutoAddress from "./components/Address/AutoAddress";
import Address from "./components/Address";
import InfoScreen from "./components/InfoScreen";
import Ssn from "./components/Ssn";
import FullSsn from "./components/FullSsn";
import Review from "./components/Review";
import Onfido from "./components/Onfido";
import Success from "./components/Success";
import PromoCodeModal from "./components/PromoCodeModal";
import TvPreferencesModal from "./components/TvPreferencesModal";
import LegalContentModal from "./components/LegalContentModal";
import { cleanRegistration } from "./utils/handlers";
import { getCurrentStep, getInfoScreenOpen } from "./utils/selectors";
import { onRegistrationSignUpStartGtmEvent } from "./utils/gtm/formCompletion";
import { onPageViewGtmEvent } from "./utils/gtm/pageViews";
import Redirect from "./components/Redirect";

export const Registration = ({ device, isMEP }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const currentStep = useSelector(getCurrentStep);
  const infoScreenOpen = useSelector(getInfoScreenOpen);
  const redirectTVGSignup = useSelector(getRedirectTVGSignup);
  const [isFormPristine, setIsFormPristine] = useState(true);

  useEffect(() => {
    if (window !== undefined) {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  }, [currentStep]);

  useEffect(() => {
    setRFRCookie(false, location);
    if (!isMEP) {
      onPageViewGtmEvent(location);
    }

    return () => {
      cleanRegistration(dispatch);
    };
  }, []);

  useEffect(() => {
    if (!isFormPristine) {
      onRegistrationSignUpStartGtmEvent();
    }
  }, [isFormPristine]);

  const mainComponent = () => {
    switch (currentStep) {
      case REGISTRATION_STEPS.SUCCESS:
        return <Success device={device} />;
      case REGISTRATION_STEPS.ONFIDO:
        return <Onfido isMEP={isMEP} device={device} />;
      case REGISTRATION_STEPS.FULLSSN:
        return <FullSsn device={device} />;
      case REGISTRATION_STEPS.REVIEW:
        return <Review device={device} />;
      case REGISTRATION_STEPS.SSN:
        return <Ssn device={device} />;
      case REGISTRATION_STEPS.ADDRESS:
        return <Address device={device} />;
      case REGISTRATION_STEPS.AUTO_ADDRESS:
        return <AutoAddress device={device} />;
      case REGISTRATION_STEPS.WELCOME:
      default:
        return (
          <Welcome
            device={device}
            isMEP={isMEP}
            isFormPristine={isFormPristine}
            setIsFormPristine={setIsFormPristine}
          />
        );
    }
  };

  return redirectTVGSignup.enabled ? (
    <Redirect />
  ) : (
    <Fragment>
      {typeof window !== "undefined" && !window.onfido && (
        // TODO: cover tvg4 while it still active
        <Helmet>
          <link
            rel="stylesheet"
            type="text/css"
            href="https://assets.onfido.com/web-sdk-releases/8.1.0/style.css"
          />
          <script
            async
            defer
            src="https://assets.onfido.com/web-sdk-releases/8.1.0/onfido.min.js"
          />
        </Helmet>
      )}
      {infoScreenOpen && <InfoScreen device={device} />}
      <PromoCodeModal device={device} />
      <TvPreferencesModal device={device} />
      <LegalContentModal device={device} />
      {!infoScreenOpen && mainComponent()}
    </Fragment>
  );
};

Registration.defaultProps = {
  device: "",
  isMEP: false,
  location: {
    pathname: "/signup",
    search: "",
    hash: ""
  }
};

export default Registration;
